/* eslint-disable object-shorthand */
export const fontColor = '#333333';
export const tooltopBgColor = '#303030';

export const chartStyle = { width: '100%', height: '100%' };

export const xAxisDateFormatStock = {
  millisecond: '%H:%M:%S.%L',
  second: '%H:%M:%S',
  minute: '%H:%M',
  hour: '%H:%M',
  day: '%b %e,%y',
  week: '%b %e,%y',
  month: '%b %e,%y',
  year: '%b %e,%y',
};

export const xAxisStyleDefault = {
  fontSize: '0.75rem',
  color: fontColor,
  fontFamily: 'Helvetica Neue,Arial,sans-serif',
};

export const yAxisStyleDefault = {
  fontSize: '0.875rem',
  color: fontColor,
  fontFamily: 'Helvetica Neue,Arial,sans-serif',
};

export const defaultToolTip = {
  style: {
    // color: '#DBDBDB',
    fontSize: '0.75rem',
    fontFamily: 'Helvetica Neue,Arial,sans-serif',
  },
  backgroundColor: tooltopBgColor,
  borderColor: tooltopBgColor,
  // hideDelay: 10000000000000,
};

export const defaultAxis = {
  gridLineDashStyle: 'Dash',
  gridLineColor: fontColor,
  opposite: false,
  title: {
    text: null,
  },
};

export const defaultLegendStyle = {
  // color: fontColor,
  fontSize: '0.75rem',
  fontFamily: 'Helvetica Neue ,Arial,sans-serif',
};

export const stackColors = [
  ['#0081E9'],
  ['#B3DCF9', '#0081E9'],
  ['#B3DCF9', '#0081E9', '#004E9E'],
  ['#B3DCF9', '#61B2F2', '#0081E9', '#004E9E'],
  ['#E0F1FD', '#67B5F2', '#0081E9', '#0050A1', '#002A69'],
  ['#E0F1FD', '#9DCFF7', '#4FA8F0', '#0081E9', '#0051A2', '#002A69'],
  ['#E0F1FD', '#A1D2F7', '#56ACF1', '#0081E9', '#006AC7', '#0052A3', '#002A69'],
  [
    '#E0F1FD',
    '#9DCFF7',
    '#66B4F2',
    '#3C9FEE',
    '#0081E9',
    '#006CCA',
    '#0052A4',
    '#002A69',
  ],
  [
    '#E0F1FD',
    '#AAD6F8',
    '#7ABEF4',
    '#3FA1EF',
    '#0081E9',
    '#0071D2',
    '#005DB5',
    '#004997',
    '#002A69',
  ],
  [
    '#E0F1FD',
    '#A2D2F8',
    '#61B2F2',
    '#2C97ED',
    '#0081E9',
    '#0071D2',
    '#0063BD',
    '#004E9E',
    '#003C84',
    '#002A69',
    '#B3DCF9',
    '#E0F1FD',
    '#F3F9FE',
  ],
];

export const NewStackColors = [
  '#0089EB',
  '#4DACF1',
  '#B3DCF9',
  '#C5C5C5',
  '#FFA929',
  '#FFDCA9',
  '#77E1C7',
  '#F1BAC3',
  '#E27588',
  '#D93954',
  '#FFECBD',
  '#FFC83D',
  '#FFB600',
  '#DCB4FC',
  '#B056F6',
];
export const defaultStackColor = '#0081E9';

export const defaultTotalRevenueChartOption = {
  chart: {
    style: {
      fontFamily: 'Helvetica Neue, Arial, sans-serif',
    },
  },
  title: {
    text: '',
    align: 'left',
    style: {
      color: '#999999',
      fontSize: '1rem',
      fontFamily: 'Helvetica Neue, Arial, sans-serif',
    },
  },
  credits: {
    enabled: false,
  },
  xAxis: {
    type: 'category',
    showEmpty: true,
    lineColor: '#666',
    labels: {
      step: 1,
      style: xAxisStyleDefault,
    },
    title: {
      text: null,
      margin: 15,
    },
    tickColor: '#333333',
    gridLineColor: '#333333',
  },
  yAxis: [
    // Primary yAxis
    {
      labels: {
        style: yAxisStyleDefault,
      },
      title: {
        text: '',
      },
      stackLabels: {
        // 堆叠数据标签
        enabled: false,
        style: {
          ...yAxisStyleDefault,
          fontSize: '0.75rem',
        },
      },
      gridLineDashStyle: 'Dash',
      gridLineColor: '#666',
      softMin: 0,
      // tickAmount: 6,
      // type: 'logarithmic',
    },
    // Secondary yAxis
    {
      labels: {
        style: yAxisStyleDefault,
      },
      title: {
        text: '',
      },
      softMax: 0,
      softMin: 0,
      gridLineDashStyle: 'Dash',
      gridLineColor: '#666',
      opposite: true,
      visible: false,
      // tickAmount: 6,
      // type: 'logarithmic',
    },
  ],
  tooltip: {},
  // tooltip: {
  //   ...defaultToolTip,
  // },
  legend: {
    layout: 'horizontal',
    align: 'center',
    // x: 120,
    verticalAlign: 'bottom',
    itemWidth: 150,
    itemStyle: defaultLegendStyle,
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      maxPointWidth: 60,
    },
    line: {
      linecap: 'round',
      stacking: 'normal',
      color: '#FFB600',
    },
    series: {
      events: {
        legendItemClick: function () {
          const showModeOn = this.chart.series.some(
            (series) => series.visible === false,
          );
          if (showModeOn) {
            return true;
          }
          this.chart.series.forEach((series) => {
            if (series.name !== this.name) {
              series.setVisible(!series.visible, false);
            }
          });
          this.chart.redraw();
          return false;
        },
      },
    },
  },
  series: [],
};

export const sentimentColors = [
  ['rgba(128,196,245,0.9)', '#006CE2'],
  // ['rgba(255,255,255,0.9)', 'rgba(172,172,172,0.9)'],
];

export const defaultSentimentChartOption = {
  chart: {
    type: 'solidgauge',
    className: 'solid-chart',
    width: null,
  },
  title: {
    useHTML: true,
    text: '1111',
    align: 'left',
    style: {
      color: '#DBDBDB',
      fontSize: '.875rem',
      // marginTop: '0.625rem',
    },
    margin: 20,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  pane: {
    startAngle: 0,
    endAngle: 360,
    background: [
      {
        // Track for Move
        outerRadius: '100%',
        innerRadius: '90%',
        backgroundColor: '#303030',
        borderWidth: 0,
      },
      {
        // Track for Exercise
        outerRadius: '85%',
        innerRadius: '75%',
        backgroundColor: '#303030',
        borderWidth: 0,
      },
    ],
  },
  yAxis: {
    min: 0,
    max: 5,
    lineWidth: 0,
    tickPositions: [],
  },
  plotOptions: {
    solidgauge: {
      dataLabels: {
        useHTML: true,
        align: 'center',
        borderWidth: 0,
        style: {
          color: '#FFFFFF!important',
          fontFamily: 'Helvetica Neue, Arial, sans-serif',
          fontWeight: 'normal',
        },
        verticalAlign: 'middle',
      },
      tooltip: {
        followPointer: true,
      },
      linecap: 'round',
      stickyTracking: false,
      rounded: true,
      className: 'solid-style',
    },
  },
  series: [
    {
      name: 'Target',
      data: [
        {
          color: sentimentColors[0][0],
          radius: '100%',
          innerRadius: '90%',
          dataLabels: {
            enabled: true,
            formatter() {
              return `<span style="font-size:0.75rem!important;">${
                this.series.name
              }  </span><span style="font-size:1.25rem!important;font-weight:bold !important;;">   ${this.y.toFixed(
                1,
              )}</span>`;
            },
            x: 120,
            y: -50,
          },
        },
      ],
    },
    {
      name: 'Buyer',
      data: [
        {
          color: sentimentColors[0][1],
          radius: '85%',
          innerRadius: '75%',
          dataLabels: {
            // useHTML: true,
            enabled: true,
            align: 'center',
            verticalAlign: 'middle',
            formatter() {
              return `<span style="font-size:0.75rem!important;">${
                this.series.name
              }   </span><span style="font-size:1.25rem!important;font-weight:bold;">   ${this.y.toFixed(
                1,
              )}</span>`;
            },
          },
        },
      ],
    },
  ],
};

export const YEARS_NEED_STACKLABEL = ['Y1', 'Y3'];
